import { render, staticRenderFns } from "./DocumentInput.vue?vue&type=template&id=36c68a0a"
import script from "./DocumentInput.vue?vue&type=script&lang=js"
export * from "./DocumentInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports